import styled from '@emotion/styled'

const Title = styled.h2`
  font-size: 1.25rem;
  align-self: flex-start;
`

export default Title
